import envConst from '../env-const'
export default function(Vue, { store }) {
  function ws() {
    let tempWSMessages = []
    let setStoreTimer = null
    let heartbeatTimer = null
    store.commit(
      'main/setWS',
      new WebSocket(
        `${envConst.WS_HOST}/scbf/ws/asset/${
          JSON.parse(localStorage.user).info.userId
        }`
      )
    )
    store.state.main.WS.onopen = () => {
      console.log('WebSocket隧道已经连接！')
      heartbeatTimer = setInterval(() => {
        store.state.main.WS.send('')
      }, 540000)
    }
    store.state.main.WS.onmessage = e => {
      let data
      try {
        data = JSON.parse(e.data)
      } catch (error) {
        data = {}
      }
      // 消息通过type区分类型：0 = 通知；1 = 事件
      if (data.type == 0) {
        let wsObj = { isNew: true, wsMessageId: data.id, ...data.payload }
        tempWSMessages.unshift(wsObj)
        clearTimeout(setStoreTimer)
        setStoreTimer = setTimeout(() => {
          store.commit('main/noticeCenter/setNotice', tempWSMessages)
          clearTimeout(setStoreTimer)
        }, 100)
      } else if (data.type == 1) {
        Vue.prototype.$eventBus.emit(data.payload.name, data.payload)
      }
    }
    store.state.main.WS.onclose = e => {
      console.log('WebSocket隧道已经关闭！', e.code)
      tempWSMessages = []
      clearInterval(heartbeatTimer)
      store.commit('main/noticeCenter/clear')
      if (e.code !== 1000) {
        console.log('30秒后重新连接')
        let timer = setTimeout(() => {
          clearTimeout(timer)
          ws()
        }, 30000)
      }
    }
  }
  window.addEventListener(
    'offline',
    () => {
      console.log('网络已断开！')
      store.state.main.WS.close()
    },
    false
  )
  window.addEventListener(
    'online',
    () => {
      console.log('网络已重新连接！')
      ws()
    },
    false
  )
  Vue.prototype.$ws = ws
}
